<template>
  <div class="bg-primary">
    <!-- Header -->
    <div class="header bg-gradient-blue py-7 py-lg-6 pt-lg-5">
      <b-container>
        <div class="header-body text-center mb-5">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Verify your email address</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-primary" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--7 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <p v-if="working" class="text-lg text-center">
                <i class="fa fa-spinner fa-spin mr-2"></i>
                Please wait&hellip;
              </p>

              <base-alert
                v-if="errorMessage"
                :dismissible="false"
                type="default"
              >Error: {{ errorMessage }}</base-alert>

              <base-alert v-if="success" :dismissible="false" type="success">
                <p class="text-lg">Your email address has been verified successfully.</p>
                <b-btn to="/" block variant="default" v-if="user">Go to dashboard</b-btn>
                <b-btn to="/login" block variant="default" v-else style="color: #fff">Log in</b-btn>
              </base-alert>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { BaseAlert } from "@/components";
import { get } from "dot-prop";

export default {
  components: {
    BaseAlert,
  },
  props: {
    userId: {
      type: String,
      description: "User ID",
      required: true,
    },
    emailAddress: {
      type: String,
      description: "Email Address",
      required: false,
    },
    token: {
      type: String,
      description: "Verification Token",
      required: true,
    },
  },
  data() {
    return {
      working: false,
      success: false,
      errorMessage: null,
    };
  },
  computed: {
    user: function () {
      return this.$auth.user();
    },
  },
  created() {
    if (this.token && this.userId) {
      this.verifyEmail();
    } else {
      this.errorMessage =
        "Unable to validate verification ticket - please try again.";
    }
  },
  methods: {
    verifyEmail() {
      this.working = true;

      const requestBody = {
        verificationToken: this.token,
      };

      this.axios
        .put(`/v1/users/${this.userId}/email-verification`, requestBody)
        .then((response) => {
          this.working = false;
          this.success = true;

          // update verified user
          if (this.user) {
            this.$auth.user().email.isVerified = true;
          }
        })
        .catch((error) => {
          this.working = false;
          this.errorMessage = `Error verifying email: ${error.response.statusText}`;
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    },
  },
};
</script>
